<template>
  <div class="carouse_manage">
    <div style="margin-bottom:20px;">
      <h1 style="text-align:left;">首页轮播图管理</h1>
      <el-divider></el-divider>
    </div>
    <div>
      <div>
        <el-button type="text" @click="dialogFormVisible = true">添加轮播图</el-button>
        <el-dialog title="添加轮播图" :visible.sync="dialogFormVisible" :open="close">
          <el-form :model="form">
            <el-form-item label="顺序" :label-width="formLabelWidth">
              <el-input v-model="form.sort" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="上传图片" :label-width="formLabelWidth">
              <el-upload
                action="/upImg.php"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :on-remove="delete_file"
                :limit="1"
                :file-list="file_list"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="图片上层文字" :label-width="formLabelWidth">
              <el-input v-model="form.upper_info" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false;file_list = [];">取 消</el-button>
            <el-button type="primary" @click="addCarouse">提 交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <el-dialog title="修改轮播图" :visible.sync="modify_dialog" :open="close">
      <el-form :model="form">
        <el-form-item label="顺序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" :label-width="formLabelWidth">
          <el-upload
            action="/upImg.php"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-remove="delete_file"
            :limit="1"
            :file-list="file_list"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="图片上层文字" :label-width="formLabelWidth">
          <el-input v-model="form.upper_info" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modify_dialog = false;file_list = [];">取 消</el-button>
        <el-button type="primary" @click="confirmModifyCarouse">修 改</el-button>
      </div>
    </el-dialog>
    <el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column label="id" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图" width="180">
        <template slot-scope="scope">{{scope.row.path}}</template>
      </el-table-column>
      <el-table-column label="顺序" width="180">
        <template slot-scope="scope">{{scope.row.sort}}</template>
      </el-table-column>
      <el-table-column label="图片上层文字" width="180">
        <template slot-scope="scope">{{scope.row.upper_info}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="modify_carouse(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row,tableData)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  name: "carouse_manage",
  data() {
    return {
      file_list: [],
      dialogFormVisible: false,
      modify_dialog: false,
      formLabelWidth: "120px",
      tableData: [
        { id: "23", path: "upload/1250.jpg", sort: "213", upper_info: "213" }
      ],
      form: {
        path: null,
        sort: null,
        upper_info: null
      }
    };
  },
  methods: {
    confirmModifyCarouse() {
      var self = this;
      this.ajax("/carousels.php", "patch", JSON.stringify(this.form), function(
        data
      ) {
        self.modify_dialog = false;
        self.$message({
          message: "修改成功",
          type: "success"
        });
        console.log(data);
      });
    },
    modify_carouse(row) {
      this.file_list = [];
      this.form = row;
      this.file_list.push({
        url: "/" + row.path,
        name: row.path
      });
      this.modify_dialog = true;
    },
    close() {
      console.log("关闭");
      this.form.path = null;
      this.form.sort = null;
      this.form.upper_info = null;
      this.file_list = [];
    },
    addCarouse() {
      var self = this;
      this.ajax("/carousels.php", "post", JSON.stringify(self.form), function(
        data
      ) {
        self.dialogFormVisible = false;
        self.form.path = null;
        self.form.sort = null;
        self.form.upper_info = null;
        self.ajax("/carousels.php", "get", null, function(data) {
          self.tableData = JSON.parse(data);
        });
        self.$message({
          message: "添加成功",
          type: "success"
        });
      });
    },
    handleDelete(index, row, rows) {
      var self = this;
      this.$confirm("是否删除该轮播图?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ajax("/carousels.php?id=" + row.id, "delete", null, function(
            data
          ) {
            rows.splice(index, 1);
            self.$message({
              message: "删除成功",
              type: "success"
            });
          });
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      this.form.path = response.replace(/\s/g, "");
    },
    delete_file(file, fileList) {
      var self = this;
      var data = {
        path: self.form.path
      };
      this.ajax("/upImg.php", "delete", JSON.stringify(data), function(data) {
        /** icon字符设置默认值 */
        self.form.path = null;
      });
    }
  },
  mounted() {
    var self = this;
    this.ajax("/carousels.php", "get", null, function(data) {
      self.tableData = JSON.parse(data);
    });
  }
};
</script>





// WEBPACK FOOTER //
// src/components/carouse_manage.vue